'use client';

import { useEffect, useState } from "react";
import { useUnit } from "effector-react";
import Cookies from "js-cookie";
import { useCitiesQuery } from "@/queries/cities/useCitiesQuery";
import { $city, setCity } from "@/shared/store/city";
import { CITY_HEADER_KEY } from "@/shared/constants/global";
import {
  Menu,
  Button,
  Icon,
} from "@chakra-ui/react";
import { LuMapPin } from "react-icons/lu";
import { IoChevronDown } from "react-icons/io5";
import { useTranslations } from "next-intl";

const DEFAULT_CITY_SLUG = "almaty";

export default function CitySelectorMenu() {
  const t= useTranslations();
  const { data: cities = [] } = useCitiesQuery();
  const city = useUnit($city);
  const [open, setOpen] = useState(false);
  const [currentCity, setCurrentCity] = useState<string>(city ?? DEFAULT_CITY_SLUG);

  // Инициализация значения из cookie
  useEffect(() => {
    const cookieCity = Cookies.get(CITY_HEADER_KEY);
    if (cookieCity) {
      setCurrentCity(cookieCity);
      setCity(cookieCity);
    } else {
      setCurrentCity(DEFAULT_CITY_SLUG);
      setCity(DEFAULT_CITY_SLUG);
      Cookies.set(CITY_HEADER_KEY, DEFAULT_CITY_SLUG, { expires: 365 });
    }
  }, []);

  const handleChange = (selectedSlug: string) => {
    setCurrentCity(selectedSlug);
    setCity(selectedSlug);
    Cookies.set(CITY_HEADER_KEY, selectedSlug, { expires: 365 });
    window.location.reload(); // или можно вызвать router.refresh() в Next 13+
  };

  return (
    <Menu.Root onOpenChange={(value) => setOpen(value.open)} onSelect={(value) => handleChange(value.value)}>
      <Menu.Trigger asChild>
        <Button variant="plain" size="lg" px={0} gap="8px" textStyle="medium20">
          <Icon boxSize={5}><LuMapPin /></Icon>
          {cities.find((c) => c.slug === currentCity)?.name || t('select_city')}
          <Icon boxSize={4} transform={open ? "rotate(180deg)" : "rotate(0deg)"} transition={"transform"}><IoChevronDown /></Icon>
        </Button>
      </Menu.Trigger>
      <Menu.Positioner>
        <Menu.Content>
          <Menu.RadioItemGroup
            value={currentCity}
            onValueChange={(e) => handleChange(e.value)}
          >
            {cities.filter((c) => c.type === "MAIN").map((c) => (
              <Menu.RadioItem key={c.slug} value={c.slug}>
                <Menu.ItemText>{c.name}</Menu.ItemText>
                <Menu.ItemIndicator />
              </Menu.RadioItem>
            ))}
          </Menu.RadioItemGroup>
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  );
}
